import ImportData from './src/import-data.vue'
import { withInstall } from '../../utils/vue/install'

export default withInstall(ImportData)